const VENUE_BOARD_HEX = [
  '#4F2D2E', '#4A321B', '#3A3A19', '#223F2B',
  '#104041', '#1F3B50', '#373450', '#482E43',
]

function hashIndex(key: string, length: number) {
  const value = String(key || '')
  let hash = 0
  for (let index = 0; index < value.length; index += 1) {
    hash = ((hash << 5) - hash) + value.charCodeAt(index)
    hash |= 0
  }
  return Math.abs(hash) % length
}

export function venueBoardTone(key: string) {
  return VENUE_BOARD_HEX[hashIndex(key, VENUE_BOARD_HEX.length)]
}

export function venueInitial(name: string) {
  return Array.from(String(name || '').trim())[0] || '馆'
}

type VenueRegion = { province?: string; city?: string; district?: string }
const REGION_SUFFIX = /(特别行政区|自治区|自治州|地区|盟|旗|省|市|区|县)$/

export function stripRegionPrefix(name: string, region: VenueRegion = {}) {
  const original = String(name || '').trim()
  if (!original) return ''
  let result = original
  let changed = true
  while (changed) {
    changed = false
    for (const raw of [region.province, region.city, region.district]) {
      const value = String(raw || '').trim()
      if (!value) continue
      const bare = value.replace(REGION_SUFFIX, '')
      for (const prefix of bare && bare !== value ? [value, bare] : [value]) {
        if (result.length > prefix.length && result.startsWith(prefix)) {
          result = result.slice(prefix.length).trim()
          changed = true
          break
        }
      }
      if (changed) break
    }
  }
  return /[一-鿿぀-ヿA-Za-z0-9]/.test(result) ? result : original
}

function dataUri(svg: string) {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`
}

export function heroCourtSvgUri() {
  const line = 'rgba(255,255,255,0.22)'
  const mesh = 'rgba(255,255,255,0.07)'
  let net = ''
  for (let index = 1; index < 5; index += 1) {
    const y = 969 + (56 * index / 5)
    net += `<line x1="185" y1="${y}" x2="895" y2="${y}" stroke="${mesh}" stroke-width="1"/>`
  }
  for (let x = 195; x < 895; x += 10) {
    net += `<line x1="${x}" y1="969" x2="${x}" y2="1025" stroke="${mesh}" stroke-width="0.8"/>`
  }
  net += `<line x1="169" y1="969" x2="911" y2="969" stroke="${line}" stroke-width="3.5"/><line x1="169" y1="1025" x2="911" y2="1025" stroke="${line}" stroke-width="2.2"/><line x1="169" y1="961" x2="169" y2="1031" stroke="${line}" stroke-width="4"/><line x1="911" y1="961" x2="911" y2="1031" stroke="${line}" stroke-width="4"/><rect x="536" y="969" width="8" height="62" fill="${line}" opacity="0.85"/>`
  const lines = `<line x1="60" y1="1380" x2="280" y2="752"/><line x1="1020" y1="1380" x2="800" y2="752"/><line x1="170" y1="1380" x2="345" y2="752" stroke-width="2.2" opacity="0.85"/><line x1="910" y1="1380" x2="735" y2="752" stroke-width="2.2" opacity="0.85"/><line x1="60" y1="1380" x2="1020" y2="1380" stroke-width="3.4"/><line x1="280" y1="752" x2="800" y2="752" stroke-width="2.6"/><line x1="200" y1="1140" x2="880" y2="1140"/><line x1="301" y1="909" x2="779" y2="909"/><line x1="540" y1="909" x2="540" y2="1140" stroke-width="2.4"/><line x1="514" y1="1380" x2="566" y2="1380" stroke-width="6"/><line x1="528" y1="752" x2="552" y2="752" stroke-width="3" opacity="0.8"/>`
  return dataUri(`<svg xmlns="http://www.w3.org/2000/svg" width="1080" height="1440" viewBox="0 0 1080 1440"><g stroke="${line}" stroke-width="3" fill="none">${lines}</g>${net}</svg>`)
}
